export const INPUT_PARAM_DEFAULTS = {
	VIN_MIN: { AC: 85, DC: 12 },
	VIN_MAX: { AC: 265, DC: 18 },
	VOUT: { AC: 12, DC: 3.3 },
	VIN_NOM: '',
	IOUT: 1,
	AMB_TEMP: 25,
	SUPPLY_TYPE: 'DC',
	LINE_FREQUENCY: 60,
	ISOLATED: false,
	AUTOMOTIVE_DESIGN: false
};

export const INPUT_PARAM_CONSTRAINTS = {
	VIN_MIN: -40,
	VIN_MAX: 1000,
	VOUT_MIN: -65,
	VOUT_MAX: 100,
	IOUT_MIN: 0,
	IOUT_MAX: 40,
	AMB_TEMP_MIN: -40,
	AMB_TEMP_MAX: 125
};
